import { Map } from "@iventis/mapbox-gl";
import { BasemapDataStore } from "../../../data-store/basemap/basemap-data-store";
import { removeSourceOnceMapIsIdle } from "../engine-mapbox-helpers";

export abstract class Basemap<TBasemap, TLayerType> {
    protected readonly id: string;

    protected readonly basemapDataStore: BasemapDataStore<TBasemap>;

    protected readonly map: Map;

    protected sourceIds: string[] = [];

    protected layers: { id: string; type: TLayerType }[] = [];

    protected removed = false;

    public loaded = false;

    constructor(id: string, basemapDataStore: BasemapDataStore<TBasemap>, map: Map) {
        this.id = id;
        this.map = map;
        this.basemapDataStore = basemapDataStore;
    }

    protected abstract addToMap(): Promise<void>;

    protected waitForMapToBeReadyToLoadSitemap() {
        // eslint-disable-next-line consistent-return
        return new Promise<void>((res) => {
            // Style has already loaded
            if (this.map.isStyleLoaded()) {
                return res();
            }
            // Wait for the map to become idle and therefor style has finished loading
            this.map.once("idle", () => {
                res();
            });
        });
    }

    /** Called when Map Engine is destoryed, will stop any loading of layers and sources which is currently happening */
    public onMapDestroy() {
        this.removed = true;
    }

    public remove() {
        // If already been removed, don't attempt it again
        if (this.removed) {
            return;
        }

        this.removed = true;

        this.layers.forEach((layer) => {
            if (this.map.getLayer(layer.id)) {
                this.map.removeLayer(layer.id);
            }
        });

        this.sourceIds.forEach((sourceId) => {
            removeSourceOnceMapIsIdle(this.map, sourceId);
        });
    }
}
